import { render } from "./DataReportView.vue?vue&type=template&id=af1658a4&scoped=true"
import script from "./DataReportView.vue?vue&type=script&lang=js"
export * from "./DataReportView.vue?vue&type=script&lang=js"

import "./DataReportView.vue?vue&type=style&index=0&id=af1658a4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af1658a4"]])

export default __exports__